import React from 'react';
import { Drawer } from 'components/common';
import PropTypes from 'prop-types';
import OverviewDetailGrid from './OverviewDetailGrid';

// Drill-down drawer hosting the shared detail grid, filtered to a clicked slice.
const DetailGridDrawer = ({ open, section, title, baseParams, extraParams, onClose }) => (
  <Drawer show={open} onHide={onClose} title={title} width="920px" minWidth="360px">
    {open && (
      <OverviewDetailGrid
        section={section}
        title={title}
        baseParams={baseParams}
        extraParams={extraParams}
        height="max(320px, calc(100dvh - 210px))"
      />
    )}
  </Drawer>
);

DetailGridDrawer.propTypes = {
  open:        PropTypes.bool.isRequired,
  section:     PropTypes.string.isRequired,
  title:       PropTypes.string,
  baseParams:  PropTypes.object.isRequired,
  extraParams: PropTypes.object,
  onClose:     PropTypes.func.isRequired
};
DetailGridDrawer.defaultProps = { title: 'Details', extraParams: {} };

export default DetailGridDrawer;
